import { createSlice } from '@reduxjs/toolkit';
import { ITeamInfoList, IMemberInfoList } from '@models/manager/account/accountModel';
import { fetchTopInfoQuota, fetchTeamInfoList, fetchMemberInfoList } from './thunks/teamThunk';
import { teamManagerViewType } from '@models/manager/account/account';

const initialState = {
  quotaInfo: null,
  teamInfoList: null as ITeamInfoList[],
  memberInfoList: null as IMemberInfoList[],
  viewState: teamManagerViewType.teamList, // 화면 컴포넌트 전환용
  isPopupOpen: false,
};

export const teamSlice = createSlice({
  name: 'team',
  initialState: initialState,
  reducers: {
    // 화면 전환처리
    setViewState: (state, { payload }: { payload: { view: teamManagerViewType } }) => {
      const { view } = payload;
      state.viewState = view;
    },
    // 팝업 열기
    setOpenPopup: (state, { payload }: { payload: { isOpen: boolean } }) => {
      state.isPopupOpen = payload.isOpen;
    },
  },
  extraReducers: {
    // quotaInfo
    [fetchTopInfoQuota.fulfilled.type]: (state, { payload }) => {
      state.quotaInfo = payload;
    },
    // teamInfoList
    [fetchTeamInfoList.fulfilled.type]: (state, { payload }) => {
      state.teamInfoList = payload;
    },
    // memberInfoList
    [fetchMemberInfoList.fulfilled.type]: (state, { payload }) => {
      state.memberInfoList = payload;
    },
    // // createTeamInfo
    // [fetchCreateTeamInfo.fulfilled.type]: (state, { payload }) => {
    //   state.teamInfoList = payload;
    //   state.isPopupOpen = false;
    // },
  },
});

export const { setViewState, setOpenPopup } = teamSlice.actions;
export const teamSliceName = teamSlice.name;
export default teamSlice.reducer;
